<template>
  <div id="stream-chat-react">
    <div v-if="error" class="h-100 bg-white p-2">
      <p>{{ error }}</p>
      <HMButton color="brand" @click="reinitializeChat">
        {{ $t('STUDIO.BUTTON.TRY_TO_RELOAD_CHAT') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { streamChatLoaded } from '@/core/services/stream';
import { StreamChat } from 'stream-chat';
import React from 'react';
import ReactDOM from 'react-dom';
import * as StreamChatReact from 'stream-chat-react';

export default {
  name: 'HMChat',
  components: {},
  props: {
    isTeacher: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    userImage: {
      type: String,
      default: '',
    },
    userToken: {
      type: String,
      default: '',
    },
    channelId: {
      type: String,
      default: '',
    },
    channelName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      communityChatClient: 'community/chatClient',
    }),
  },
  data() {
    return {
      chatClient: null,
      channel: null,
      channelState: null,
      members: [],
      error: null,
    };
  },
  methods: {
    async reinitializeChat() {
      await this.initializeChat();
    },
    async initializeChat() {
      await streamChatLoaded();
      try {
        // Get chat client from store, or create a new instance if not available
        if (this.communityChatClient) {
          this.chatClient = this.communityChatClient;
        } else {
          this.chatClient = StreamChat.getInstance(
            process.env.VUE_APP_STREAM_CHAT_API_KEY
          );
          // Store the instance for other components to use
          this.$store.dispatch('community/communityChatClient', {
            chatClient: this.chatClient,
          });
        }

        console.log('this.chatClient', this.chatClient);

        // Only disconnect if client exists and has a connected user
        if (this.chatClient && this.chatClient.userID) {
          await this.chatClient.disconnectUser();
        }

        await this.chatClient.connectUser(
          {
            id: this.userId,
            name: this.userName,
            image: this.userImage,
          },
          this.userToken
        );

        this.channel = this.chatClient.channel('livestream', this.channelId, {
          name: this.channelName,
        });

        if (this.isTeacher) {
          this.channelState = this.channel.watch().then(res => {
            if (res.members) this.members = res.members;

            this.$emit('membersUpdated', this.members);
            this.channel.on('member.added', async newMember => {
              // console.log('new Member: ', newMember);
              const queryMembers = await this.channel.queryMembers({
                user_id: newMember.user.id,
              });

              this.members = this.members.concat(queryMembers.members);
              this.$emit('membersUpdated', this.members);
            });
            this.channel.on('member.removed', member => {
              // console.log('removed Member: ', member);
              this.members = this.members.filter(
                existingMember => existingMember.user.id !== member.user.id
              );
              this.$emit('membersUpdated', this.members);
            });
            this.channel.on('message.new', newMessage => {
              // console.log('new Message: ', newMessage);
              this.$emit('newMessage', newMessage);
            });
          });
        }
        this.renderStreamChatReact();
      } catch (error) {
        console.error('error=', error);
        this.error = error;
        alert('Failed to load chat, please refresh your page!');
      } finally {
      }
    },
    streamChatReactApp() {
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          StreamChatReact.Chat,
          {
            client: this.chatClient,
            theme: 'livestream light',
          },
          React.createElement(
            StreamChatReact.Channel,
            {
              channel: this.channel,
            },
            React.createElement(
              StreamChatReact.Window,
              {
                hideOnThread: true,
              },
              React.createElement(StreamChatReact.MessageList, {
                //Message: StreamChatReact.MessageLivestream,
                Message: StreamChatReact.MessageTeam,
              }),
              React.createElement(StreamChatReact.MessageInput, null)
            ),
            React.createElement(StreamChatReact.Thread, {
              Message: StreamChatReact.MessageLivestream,
              fullWidth: true,
            })
          )
        )
      );
    },
    renderStreamChatReact() {
      ReactDOM.render(
        this.streamChatReactApp(),
        document.getElementById('stream-chat-react')
      );
    },
  },
  mounted() {
    this.initializeChat();
  },
  async beforeDestroy() {
    try {
      if (this.chatClient) await this.chatClient.disconnectUser();
    } catch (error) {
      console.log(error);
    }
    try {
      if (this.channelState) {
        this.channelState.stopWatching();
      }
    } catch (error) {}
    try {
      ReactDOM.unmountComponentAtNode(
        document.getElementById('stream-chat-react')
      );
    } catch (error) {}
  },
};
</script>

<style lang="scss">
@import '~stream-chat-react/dist/css/index.css';
@import '@/web/styles/components-variables.scss';

stream-chat-react,
#stream-chat-react,
.full-chat {
  height: 100%;
  border-left: 1px solid #e1e1e1;
  z-index: 1001;
  /*
    @media screen and (max-width: $screen-sm-min){
      border-left: none;
    }
    */
}

.str-chat {
  height: 100%;
}

.str-chat.str-chat-channel {
  /*height: calc(100vh - 105px);*/
  background-color: white;

  /*
    @media screen and (max-width: $screen-sm-min){
      height: calc(100vh - 95px);
    }

    @media screen and (max-width: $screen-sm-min) and (orientation: portrait){
      height: 35vh;
    }
    */
}

.full-chat .str-chat.str-chat-channel {
  height: 100%;
}

.str-chat__fileupload-wrapper {
  display: none;
}

.str-chat__header-hamburger,
.str-chat__input-footer,
.str-chat__header-livestream-left--members {
  display: none !important;
}

.str-chat__header-livestream {
  min-height: 50px !important;
}

.str-chat__input-flat .str-chat__textarea > textarea:focus {
  box-shadow: 0 0 0 1px var(--brand-color, $coral);
}

.str-chat__send-button path {
  fill: var(--brand-color, $coral);
}

.str-chat__input-flat-emojiselect {
  border: none;
  outline: none;
}

// fix for overlapping message author names
.str-chat__message-data,
.str-chat__message-simple-data {
  position: static !important;
}
</style>
